import { register } from '@shopify/theme-sections';
import  { Swiper , Autoplay } from 'swiper';

const selectors = {
  container: '.notification-bar--',
  target: '.notification-bar__slider--',
};

Swiper.use([Autoplay]);

register('notification-bar', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  /**
   * Callback function when section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
   */
  cleanSlide(id) {
    const target = `${selectors.target}${id}`;
    const container = `${selectors.container}${id}`;
    const containerSelector = document.querySelector(container);
    const slideSize = containerSelector.dataset.slideSize;
    const loop = this.returnLoop(slideSize);

    const swiper = new Swiper(target, {
      slidesPerView: 1,
      loop: true,
      allowTouchMove: false,
      autoplay: loop,
    });
  },

  returnLoop(slideSize) {
    if (slideSize > 1) {
      const loop = { delay: 3000, }
      return loop;
    } else {
      return false;
    }
  },

  onBlockSelect: (blockId) => {
    const id = blockId.detail.sectionId;
    const currentSlide = parseInt(blockId.target.dataset.swiperSlideIndex) + 1;
    const target = `${selectors.target}${id}`;
    const swiper = document.querySelector(target).swiper;
    swiper.slideTo(currentSlide, 1000, false);

    console.log(`🤠 Slide to block ${currentSlide}`);
  },
});
